module.exports = __webpack_public_path__ + "img/dual-temperature-md.c5f78abb.svg";